import { call, put } from "redux-saga/effects";
import { fetchScanStatusData } from "../api/scanStatusDataApi";
import { errorRetrievingScanStatusData, noResultsScanStatusData, receiveScanStatusData } from "../actions/scanStatusDataActions";


// worker Saga: will be fired on USER_FETCH_REQUESTED actions
export default function* getScanStatusData(action) {
  try {
    // do api call
    const data = yield call(fetchScanStatusData, action.payload);

    if (!data.piece || data.piece.length === 0) {
      yield put(noResultsScanStatusData());
    } else {
      const scanStatuses = data.piece.flatMap(p =>
        (p.scans || []).map(scan => ({
          scanType: scan.scanType,
          scanTime: scan.scanTime,
          scanStation: scan.scanStation,
          flightNumber: scan.flightNumber,
          scanCount: p.pieceNumber
        }))
      );
      yield put(receiveScanStatusData({ scanStatuses }));
    }

  } catch (e) {
    console.log("ERROR");
    yield put(errorRetrievingScanStatusData(e.message));
  }
}



// WEBPACK FOOTER //
// ./src/sagas/scanStatusSaga.js